import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { COLORS } from "../hooks/useAudioRecorder";

/**
 * Standard back-navigation link used at the top-left of every non-home page.
 *
 * Visual: ChevronLeft + uppercase mono label, ink-dim color. Sits flush-left
 * inside the page header. Yellow is reserved for primary CTAs across the
 * app, so back nav stays subtle.
 */
export default function BackLink({ to, label, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      aria-label={`Back to ${label}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        color: COLORS.faint,
        textDecoration: "none",
        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        fontSize: 11,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
      }}
    >
      <ChevronLeft size={14} />
      {label}
    </Link>
  );
}
